import { Outlet } from 'react-router';

export default function BlankLayout() {
  return (
    <div className="flex h-full min-h-screen flex-col">
      <Outlet />
    </div>
  );
}
